import * as Externals from './externals';

export const EventTypes = Externals.EventTypes;
export const EventNames = Externals.EventNames;

export const Actions = Object.freeze({
  LOG_EVENT: 'logAnalyticsEvent',
});

export const StatsPageViewNames = Object.freeze({
  ACCOUNT_SETTINGS: 'account_settings',
  ANONYMOUS_LISTENING_TIMEOUT: 'anonymous_listening_timeout',
  ANONYMOUS_LISTENING: 'anonymous_listening',
  ATT_PREMIUM: 'ATT_premium',
  ATT_REGISTRATION: 'ATT_registration',
  BACK: 'back',
  BACKSTAGE_ALBUM_DESCRIPTION: 'backstage_album_description',
  BACKSTAGE_ALBUM: 'backstage_album',
  BACKSTAGE_ARTIST_ALL_ALBUMS: 'backstage_artist_all_albums',
  BACKSTAGE_ARTIST_ALL_PLAYLISTS: 'backstage_artists_all_playlists',
  BACKSTAGE_ARTIST_ALL_SONGS: 'backstage_artist_all_songs',
  BACKSTAGE_ARTIST_ALL_STATIONS: 'backstage_artist_all_stations',
  BACKSTAGE_ARTIST_FULL_BIO: 'backstage_artist_full_bio',
  BACKSTAGE_ARTIST_CURATOR: 'backstage_artist_curator',
  BACKSTAGE_ARTIST: 'backstage_artist',
  BACKSTAGE_CURATOR: 'backstage_curator',
  BACKSTAGE_CURATOR_ALL_PLAYLISTS: 'backstage_curator_all_playlists',
  BACKSTAGE_CURATOR_ALL_STATIONS: 'backstage_curator_all_stations',
  BACKSTAGE_CURATOR_FULL_BIO: 'backstage_curator_full_bio',
  BACKSTAGE_GENRE: 'backstage_genre',
  BACKSTAGE_PODCAST_ALL_EPISODES: 'backstage_podcast_all_episodes',
  BACKSTAGE_PODCAST_EPISODE_DESCRIPTION: 'backstage_podcast_episode_description',
  BACKSTAGE_PODCAST_EPISODE: 'backstage_podcast_episode',
  BACKSTAGE_PODCAST_PROGRAM_DESCRIPTION: 'backstage_podcast_program_description',
  BACKSTAGE_PODCAST_PROGRAM: 'backstage_podcast_program',
  BACKSTAGE_PODCAST_THUMBED_DOWN_EPISODES: 'backstage_podcast_thumbed_down_episodes',
  BACKSTAGE_PODCAST_THUMBED_UP_EPISODES: 'backstage_podcast_thumbed_up_episodes',
  BACKSTAGE_TRACK_CREDITS: 'backstage_track_credits',
  BACKSTAGE_TRACK_LYRICS: 'backstage_track_lyrics',
  BACKSTAGE_TRACK_SIMILAR_SONGS: 'backstage_track_similar_songs',
  BACKSTAGE_TRACK: 'backstage_track',
  BROWSE_DEEP: 'deep_browse',
  BROWSE_MAIN: 'browse_main',
  BROWSE: 'browse',
  COLLECTION: 'collection',
  CONTENT_SETTINGS: 'content_settings',
  FAMILY_PLAN: 'family_plan',
  FORGOT_PASSWORD: 'forgot_pw',
  GENRES: 'genres',
  LANDING_PAGE: 'landing_page',
  LOGIN_CAPTCHA: 'login_captcha',
  LOGIN_FAILED: 'login_failed',
  LOGIN_SUCCESS: 'login_success',
  LOGIN: 'login',
  LOGOUT: 'sign_out',
  MY_MUSIC: 'my_music',
  MY_STATIONS: 'my_stations',
  NOTIFICATION_SETTINGS: 'notification_settings',
  NOW_PLAYING_PREMIUM: 'now_playing_premium',
  NOW_PLAYING: 'now_playing',
  PARTNER_UPGRADE: 'partner_upgrade',
  PAYMENT_FAMILY: 'payment_family',
  PAYMENT_MILITARY: 'payment_military',
  PAYMENT_PLUS: 'payment_plus',
  PAYMENT_PREMIUM: 'payment_pandora_premium',
  PAYMENT_STUDENT: 'payment_student',
  PAYMENT: 'payment',
  PLAYLIST: 'playlist',
  PROFILE_BOOKMARKS_ALBUMS: 'profile_bookmarks_albums',
  PROFILE_BOOKMARKS_ARTISTS: 'profile_bookmarks_artists',
  PROFILE_BOOKMARKS_TRACKS: 'profile_bookmarks_tracks',
  PROFILE_THUMBS: 'profile_thumbs',
  PROFILE: 'profile',
  REDEEM_CODE: 'redeem_code',
  REGISTRATION_BLOCKED: 'registration_blocked',
  REGISTRATION_EXISTING_ACCOUNT: 'registration_existing_account',
  REGISTRATION_SUCCESS: 'registration_success',
  REGISTRATION: 'registration',
  RESET_PASSWORD_CAPTCHA: 'pwd_reset_captcha',
  RESET_PASSWORD: 'pwd_reset',
  REVERIFICATION_STUDENT: 'reverify_student',
  SEARCH: 'search',
  SERVICE_ERROR: 'service_error',
  SESSION_HISTORY_PREMIUM: 'session_history_premium',
  SESSION_HISTORY: 'session_history',
  STATION_DETAILS: 'station_details',
  SUBSCRIPTION_WELCOME: 'subscription_welcome',
  SUBSCRIPTION: 'subscription',
  UPGRADE_FAMILY_PLAN: 'pandora_premium_family',
  UPGRADE_FAMILY: 'upgrade_family_plan_page',
  UPGRADE_LANDING: 'upgrade_landing_page',
  UPGRADE_MILITARY: 'upgrade_military_page',
  UPGRADE_PAGE: 'upgrade_page',
  UPGRADE_PLUS: 'upgrade_plus_plan_page',
  UPGRADE_PREMIUM_PAGE: 'upgrade_premium_page',
  UPGRADE_PREMIUM: 'pandora_premium',
  UPGRADE_STUDENT: 'upgrade_student_page',
  UPGRADE: 'upgrade',
  VERIFICATION_MILITARY: 'verify_military',
  VERIFICATION_STUDENT: 'verify_student',
  VIEW: 'view',
});
